// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2fhfi","colMin":"styles_colMin__1UoWk","colCheckbox":"styles_colCheckbox__1jBFP"};